// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Serbia */
const RS = /^(?:6(?:[0-689]|7\d)\d{6,7})$/;

export default RS;
